(function () {
  var overlay = document.querySelector('[data-nav-overlay]');
  var drawer = document.querySelector('[data-nav-drawer]');
  var closeBtn = document.querySelector('[data-nav-close]');
  var openBtns = document.querySelectorAll('[data-nav-open]');

  function open() {
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
})();
